<template>
  <div class="dataTableContainer">
    <v-card class="dataTableCard pa-0" :class="{'rounded-0 elevation-0': $vuetify.breakpoint.xsOnly}">
      <v-card-title class="dataTableHeader">
        <v-row align="center" justify="space-between">
          <v-col lg="8" md="8" sm="6" align-self="center">
            <v-text-field
              class="searchBar"
              v-model="search"
              prepend-inner-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="auto"
                 :class="{'buttonWrapper': $vuetify.breakpoint.smAndUp, 'createNotificationButtonMobile': $vuetify.breakpoint.xsOnly}">
            <AdsButton
              :button-text="$vuetify.breakpoint.xs ? 'Create' : 'Create notification'"
              :style="$vuetify.breakpoint.xs ? {'width': '110px'} : {'width': '220px'}"
              icon="add_circle_outline"
              class="createNotificationButton"
              @click="createNotification"
              :disabled="disabledCreateNotification"
              v-if="$vuetify.breakpoint.smAndUp"
            />
            <button v-if="$vuetify.breakpoint.xsOnly"
                    class="createNotificationMobileWrapper"
                    @click="createNotification">
              <FeatureIcon
                size="60"
                icon-size="36"
                color="#FFFFFF"
                background-color="#041E42"
                icon="add"
                class="createNotificationMobile"
              />
            </button>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :no-data-text="noDataText"
        :loading="$store.getters.isLoadingNotificationsTable"
        :headers="headers"
        :items="items"
        :search="search"
        class="dataTable"
        id="dataTable"
        @click:row="openNotificationDetails"
      >
        <template v-slot:item.created="{ item }">
          {{ formatDate(item.createdDatetime) }}
        </template>
        <template v-slot:item.method="{ item }">
          <span>{{ getMethod(item) }}</span>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :outlined="item.status === 'Draft'"
            :class="'chip chip' + item.status"
          >
            {{ item.status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="actionsContainer" v-if="item.status === 'Draft' || item.status === 'Rejected'">
            <v-icon
              class="ml-2"
              role="button"
              @click="editItem(item.draftId)"
            >
              mdi-pencil-outline
            </v-icon>
            <v-icon
              class="ml-2"
              @click="showDeleteDialog(item)"
            >
              delete_outline
            </v-icon>
          </div>
          <v-icon
            v-else
            class="ml-2"
            @click="copyItem(item)"
          >
            content_copy
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <DiscardDialog v-model="deleteDialog" :delete-item="deleteItem" :show-delete-dialog="showDeleteDialog"/>
  </div>
</template>

<script>
import {AdsButton, FeatureIcon} from '@nswdoe/doe-ui-core';
import DiscardDialog from "@/components/DiscardDialog";
import moment from "moment";

export default {
  name: 'Datatable',
  components: {
    DiscardDialog,
    AdsButton,
    FeatureIcon
  },
  props: {
    headers: Array,
    rows: Array,
    filters: Object,
  },
  data: function () {
    return {
      deleteDialog: false,
      editDialog: false,
      item: {},
      search: '',
      clickedAction: false,
      disabledCreateNotification: false,
    }
  },
  computed: {
    items() {
      let items = [];
      for (let row of this.rows) {
        items.push(this.clone(row));
        if (row.displayMethod === 'qplus_banner') {
          items[items.length - 1].method = 'banner';
        }
      }
      let filters = this.filters;
      return this.filterItems(items, filters);
    },
    noDataText() {
      if (this.$store.getters.failedFetchNotifications) {
        return "There was an error when fetching the notifications.";
      } else {
        return "No results.";
      }
    }
  },
  watch: {
    deleteDialog(val) {
      if (!val) {
        this.clickedAction = false;
      }
    }
  },
  methods: {
    clone(object) {
      if (!object) {
        return object;
      } else if (Array.isArray(object)) {
        return object.map(item => this.clone(item));
      } else if (typeof object === 'object') {
        const result = {};
        Object.entries(object).forEach(([key, value]) => {
          result[key] = this.clone(value);
        })
        return result;
      }
      return object;
    },
    filterItems(items, filters) {
      if (!filters) return items;

      Object.keys(filters).forEach(column => {
        if (filters[column].length === 0) {
          delete filters[column];
        }
      });

      if (Object.keys(filters).length === 0) return items;

      for (let column of Object.keys(filters)) {
        items = items.filter(item => {
          for (let keyword of filters[column]) {
            if (item[column].includes(keyword)) return true;
          }
          return false;
        });
      }

      return items;
    },
    formatDate(date) {
      return moment(new Date(date)).format("DD MMM YYYY");
    },
    getMethod(item) {
      if (item.method === 'banner') {
        return 'Important notices banner';
      } else {
        return 'Notification drawer';
      }
    },
    showDeleteDialog(item) {
      this.clickedAction = true;
      this.deleteDialog = !this.deleteDialog;
      this.item = item;
      if (!this.deleteDialog) this.item = {};
    },
    editItem(id) {
      this.clickedAction = true;
      this.$router.push(`/notifications/${id}`).catch(() => {
      });
    },
    deleteItem() {
      this.$store.dispatch("deleteNotification", this.item.draftId)
        .finally(() => {
          this.deleteDialog = false;
        });
    },
    copyItem(item) {
      this.clickedAction = true;
      this.$store.dispatch('copyNotification', item);
    },
    createNotification() {
      this.$router.push({name: 'qPlusCreateNotifications'});
    },
    openNotificationDetails(item) {
      if (this.clickedAction) {
        this.clickedAction = false;
      } else {
        this.$router.push(`/notifications/${item.draftId}`).catch(() => {
        });
      }
    },
  }
}
</script>
<style lang="scss" scoped>

.createNotificationButtonMobile {
  position: fixed;
  bottom: 1vh;
  right: 2vw;
  z-index: 100;
}

.createNotificationMobile {
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 25%);
}

.dataTableCard {

  .dataTableHeader {
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid #E4E4E6;
  }

  .searchBar {
    padding-top: 0;
    margin-top: 0;
  }

  .buttonWrapper {
    display: flex;
    justify-content: flex-end;

    .createNotificationButton {
      height: 48px !important;
      //width: 220px !important;

      &:focus {
        border: 3px solid #407EC9 !important;
        border-radius: 4px;

        &:before {
          opacity: 0 !important;
        }
      }
    }
  }
}

::v-deep.v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
  width: 0 !important;
}

.dataTable {
  margin-bottom: 36px;
}

::v-deep.dataTable .text-start[role=columnheader], ::v-deep.dataTable .text-end[role=columnheader] {
  padding-left: 24px !important;
  border-bottom: 1px solid #E4E4E6 !important;
  font-size: 14px !important;
  color: #041E42 !important;
}

::v-deep.dataTable .text-start {
  padding-left: 24px !important;
  border-bottom: none !important;
  height: 60px;
}

::v-deep.dataTable .text-end {
  padding-right: 24px !important;
  border-bottom: none !important;
}

::v-deep.dataTable tbody tr {
  cursor: pointer !important;
}

::v-deep.dataTable .v-data-footer {
  border-top: 1px solid #E4E4E6 !important;
}

@media only screen and (max-width: 600px) {
  ::v-deep.dataTable .v-data-footer {

    button {
      width: 20px !important;
    }
  }

 ::v-deep #dataTable  .v-input__slot:before {
   content: none;
 }
}

.chip {
  width: 120px;
  height: 24px;
  font-weight: bold;
  display: flex;
  justify-content: center;
}

.chipPending {
  background-color: #C8DCF0 !important;
  color: #041E42 !important;
  border-color: #C8DCF0 !important;
}

.chipSent {
  background-color: #00A908 !important;
  color: #FFFFFF !important;
  border-color: #00A908 !important;
}

.chipScheduled {
  background-color: #2E5299 !important;
  color: #FFFFFF !important;
  border-color: #2E5299 !important;
}

.chipRejected {
  background-color: #B81237 !important;
  color: #FFFFFF !important;
  border-color: #B81237 !important;
}

.chipDraft {
  background-color: #FFFFFF !important;
  color: #041E42 !important;
  border-color: #041E42 !important;
}

</style>
